import {parse} from 'date-fns';
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";

export const dateUtils = {
  fromDateStrToDate(dateStr: string): Date {
    return parse(dateStr, 'dd/MM/yyyy', new Date());
  },

  formatDateStruct(date: Date | null, frFormat: boolean = true): string {
    if (!date) return '';

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    if (frFormat) {
      return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
    } else {
      return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} 00:00`;
    }
  },


  toDate(dateStruct: NgbDateStruct | null): Date {
  if (!dateStruct) return new Date();
  return new Date(dateStruct.year, dateStruct.month - 1, dateStruct.day);
},

  getToday(): NgbDateStruct {
    const today = new Date();
    return {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate()
    };
  },

  parseDateToNgbDateStruct(dateStr: string): NgbDateStruct {
  let day: number, month: number, year: number;

  if (dateStr.includes('/')) {
    [day, month, year] = dateStr.split('/').map(Number);
  }
  else if (dateStr.includes('-')) {
    const [datePart] = dateStr.split(' ');
    [year, month, day] = datePart.split('-').map(Number);
  } else {
    throw new Error('Invalid date format');
  }

  return { year, month, day };
}

};
